export const convertToSubcriberDate = (date) => {
  const newDate = new Date(date);
  const customFormat = `${newDate.getUTCFullYear()}-${String(
    newDate.getUTCMonth() + 1
  ).padStart(2, "0")}-${String(newDate.getUTCDate()).padStart(2, "0")}`;
  return customFormat;
};

export const convertInMonthNameFormat = (date) => {
  return new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  });
};

export const highlightText = (text, highlight) => {
  if (!text) return "";
  if (!highlight) return text;
  if (!highlight.trim()) {
    return text;
  }
  const regex = new RegExp(`(${highlight})`, "gi");
  const parts = text.split(regex);
  return parts.map((part, index) =>
    regex.test(part) ? (
      <span
        key={part + index}
        style={{ backgroundColor: "#5B68C3", color: "white" }}
      >
        {part}
      </span>
    ) : (
      part
    )
  );
};
export const highlightMultipleTexts = (text, highlights) => {
  const filteredHighlights = highlights.filter((highlight) => highlight.trim());
  if (!filteredHighlights.length) {
    return text;
  }
  const regex = new RegExp(`(${filteredHighlights.join("|")})`, "gi");
  const parts = text.split(regex);
  return parts.map((part, index) =>
    regex.test(part) ? (
      <span
        key={part + index}
        style={{ backgroundColor: "#5B68C3", color: "white" }}
      >
        {part}
      </span>
    ) : (
      part
    )
  );
};

export function stripHtml(html = "") {
  if (!html) return "";
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent?.trim() || "";
}

export const cleanHTML = (text) => {
  if (!text) return "";
  return text.replace(/<[^>]*>/g, "").trim();
};
